export default __webpack_public_path__ + "locales/uk-UA/DeleteDialog.json?hash=65c48f7398a7fb006710fcbd78c91582";